
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'TriggerVariableCard'
})
export default class TriggerVariableCard extends Vue {
  @Prop({ type: Array, required: true, default: [] })
  readonly variables!: string[]

  @Prop({ type: Array, required: false, default: () => [] })
  readonly isCheckedArray!: boolean[]

  formatVariable(variable: string): string {
    return `{{ ${variable} }}`
  }
}
